module.exports = __webpack_public_path__ + "static/media/lost.4375e379.png";